import clsx from 'clsx';

import { IStatusLabelProps } from '@src/types';

import styles from './questionStatusLabel.module.scss';
import useQuestionStatusLabel from './useQuestionStatusLabel';

const QuestionStatusLabel = ({ question }: IStatusLabelProps) => {
  const { statusLabel, statusType } = useQuestionStatusLabel({ question });

  if (!statusLabel) return null;

  return <div className={clsx(styles.questionStatusLabel, styles[statusType ?? ''])}>{statusLabel}</div>;
};

export default QuestionStatusLabel;
